/* Pure Desi — Diwali 2026 cart-driven order mode (2026-09-09).
   Spec: Docs/superpowers/specs/2026-09-05-diwali-2026-preorder-mode-design.md §4–§7.
   One order type per checkout: Bird schedules ONE date + ONE method per order.
   This file: pure mode logic (unit-tested in Node), the add intercept, the
   switch dialog, /cart.js sync, client-side lock re-application after ajax
   adds, and the cart-page resolve buttons. Server-rendered Liquid
   (pd-mode.liquid) is the source of truth for the first paint; this script
   keeps the page honest after ajax changes.
   ES5 on purpose (no build step, same as pd-ux.js). */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (root && root.document) { root.PDDiwaliMode = api; api._boot(root); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var NONE = 'none', DIWALI = 'diwali', EVERYDAY = 'everyday', MIXED = 'mixed', ANY = 'any';
  var PROP = '_order_type', PROP_VAL = 'diwali-preorder', PTYPE = 'Diwali Gift Box';

  /* ---------- pure ---------- */
  function lineType(item) {
    if (!item) return EVERYDAY;
    var p = item.properties;
    if (p && p[PROP] === ANY) return ANY;          /* tagged "Any Order": rides in either order type */
    if (p && p[PROP] === PROP_VAL) return DIWALI;
    if (item.product_type === PTYPE) return DIWALI;
    return EVERYDAY;
  }
  function resolveMode(items) {
    var d = false, e = false, i, t;
    items = items || [];
    for (i = 0; i < items.length; i++) { t = lineType(items[i]); if (t === ANY) continue; if (t === DIWALI) d = true; else e = true; }
    if (d && e) return MIXED;
    if (d) return DIWALI;
    if (e) return EVERYDAY;
    return NONE;
  }
  function conflicts(mode, formType) {
    if (formType === ANY) return false;             /* never blocked, in any mode */
    if (mode === MIXED) return true;
    if (mode === NONE || !mode) return false;
    return mode !== formType;
  }
  function dialogCopy(mode, target) {
    if (mode === MIXED) {
      return {
        title: 'Your bag needs sorting first',
        body: 'Your bag holds both Diwali pre-order items and everyday items. They are placed as separate orders, so pick which one to keep in your bag before adding more.',
        switchLabel: null
      };
    }
    if (mode === DIWALI) {
      return {
        title: 'One order type at a time',
        body: 'Your bag holds a Diwali pre-order. Everyday sweets are placed as a separate order, because every order carries one date and one pickup or delivery choice.',
        switchLabel: 'Empty bag and shop everyday'
      };
    }
    return {
      title: 'One order type at a time',
      body: 'Your bag holds everyday sweets. Diwali pre-orders are placed as a separate order, because every order carries one date and one pickup or delivery choice.',
      switchLabel: 'Empty bag and start pre-order'
    };
  }
  function lockLabel(mode) {
    if (mode === DIWALI) return 'Finish Diwali order first';
    if (mode === EVERYDAY) return 'Finish everyday order first';
    return 'Sort out your bag first';
  }

  /* ---------- browser ---------- */
  var doc = null, pending = null;
  function hasFetch() { return typeof fetch === 'function'; }
  function current() { return (doc && doc.body && doc.body.getAttribute('data-pd-mode')) || NONE; }
  function setMode(m) {
    if (!doc || !doc.body) return;
    if (doc.body.getAttribute('data-pd-mode') !== m) doc.body.setAttribute('data-pd-mode', m);
    applyLocks(m);
    termsLinks(m);
    try { doc.dispatchEvent(new CustomEvent('pd-mode', { detail: m })); } catch (e) { /* old browsers */ }
    if (doc.body.classList.contains('template-cart')) { arrangeBird(m); birdGate(m); }
  }
  /* v2.7 (2026-09-12): the cart terms checkbox links to the Diwali pre-order
     terms while the bag is a pre-order (or mixed), else the general T&C.
     First paint comes from snippets/pd-terms-label.liquid; this keeps it
     right after ajax adds. */
  function termsLinks(m) {
    if (!doc) return;
    var dw = (m === DIWALI || m === MIXED);
    var links = doc.querySelectorAll('[data-pd-terms-link]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', dw ? '/pages/diwali-pre-order-policy' : '/pages/terms-conditions');
      links[i].textContent = dw ? 'Diwali pre-order terms' : 'terms and conditions';
    }
  }
  function sync() {
    if (!hasFetch()) return Promise.resolve(null);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && c.items) setMode(resolveMode(c.items)); return c; })
      .catch(function () { return null; });
  }

  /* Client-side lock: every product form carries data-pd-type. When it conflicts
     with the mode, its host (.product-item card, or the PDP product-form) gets
     .pd-locked and the button text becomes the lock label. The button stays
     enabled on purpose: clicking it opens the dialog. */
  function setText(txt, locked, mode) {
    if (!txt) return;
    if (!txt.hasAttribute('data-pd-orig')) txt.setAttribute('data-pd-orig', txt.textContent);
    txt.textContent = locked ? lockLabel(mode) : txt.getAttribute('data-pd-orig');
  }
  function applyLocks(mode) {
    if (!doc) return;
    var forms = doc.querySelectorAll('form[data-pd-type]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      /* toggle on every host Liquid might have stamped: the card, the
         quick-add wrapper and the PDP product-form */
      var hosts = [f.closest('.product-item'), f.closest('quick-add-to-cart'), f.closest('product-form')].filter(Boolean);
      if (!hosts.length) hosts = [f];
      var btn = f.querySelector('[data-js-product-add-to-cart], [data-js-pd-upsell-add], button[type="submit"]');
      var txt = btn && (btn.querySelector('.button__text') || btn);
      var locked = conflicts(mode, f.getAttribute('data-pd-type'));
      for (var h = 0; h < hosts.length; h++) hosts[h].classList.toggle('pd-locked', locked);
      setText(txt, locked, mode);
    }
    /* quick-view anchors on multi-variant cards */
    var qv = doc.querySelectorAll('quick-view-product[data-pd-type]');
    for (var j = 0; j < qv.length; j++) {
      var lockedQv = conflicts(mode, qv[j].getAttribute('data-pd-type'));
      qv[j].classList.toggle('pd-locked', lockedQv);
      var qvCard = qv[j].closest('.product-item'); if (qvCard) qvCard.classList.toggle('pd-locked', lockedQv);
      setText(qv[j].querySelector('.button__text'), lockedQv, mode);
    }
    /* PDP lock panel rendered by pd-pdp-lock.liquid */
    var panels = doc.querySelectorAll('[data-pd-pdp-lock]');
    for (var k = 0; k < panels.length; k++) {
      var on = conflicts(mode, panels[k].getAttribute('data-pd-ptype'));
      panels[k].hidden = !on;
      panels[k].classList.toggle('pd-pdp-lock--on', on);
      /* the buy box is not a sibling of the panel (the theme wraps blocks), so
         flag the whole product section and let CSS hide the form + sticky bar */
      var sec = panels[k].closest('[id^="shopify-section"]') || doc.body;
      sec.classList.toggle('pd-pdp-locked', on);
      doc.body.classList.toggle('pd-pdp-locked', on); /* sticky add-to-cart bar lives outside the section */
    }
  }

  /* Bird location list (Abhi, 2026-09-09): a Diwali bag sees its four Diwali
     pickup locations first and the everyday stores hidden; an everyday bag
     does not see the Diwali locations. Deliberate, contained exception to the
     "Bird is frozen" rule: it reads Bird's rendered list by the location NAME
     (contains "Diwali"), reorders/hides, and selects the first visible entry
     if the preselected one was hidden. If Bird's markup changes the selectors
     miss and this does nothing. Bird's own availability rules still apply. */
  var birdBusy = false;
  function arrangeBird(mode) {
    if (!doc || birdBusy) return;
    var list = doc.querySelector('#birdchime-slots-box .bird-location-list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.bird-location-item'));
    if (!items.length) return;
    birdBusy = true;
    try {
      var isDiwali = function (it) { var n = it.querySelector('.bird-location-item__name'); return /diwali/i.test(n ? n.textContent : it.textContent); };
      var show = function (it, on) { it.classList.toggle('pd-bird-hidden', !on); };
      /* 27 Oct 2026 (Abhi): every bag shows only the four Diwali pickup stores, at the top. The regular stores are
         blocked in Bird from 30 Oct to 14 Nov and the Diwali stores take "Any Order" items, so everyday shoppers
         were picking stores with no dates. Ends by itself when the Diwali stores close (15 Nov 2026, Sydney). */
      var diwaliStoresOnly = Date.now() < Date.parse('2026-11-15T00:00:00+11:00');
      /* also bags holding only "Any Order" items (tea, pickles, saffron): their mode is NONE (27 Oct, Abhi: tea blend showed Pure Desi Sydney first) */
      if (mode === DIWALI || mode === MIXED || (diwaliStoresOnly && (mode === EVERYDAY || mode === NONE))) {
        var diwali = items.filter(isDiwali), rest = items.filter(function (it) { return !isDiwali(it); });
        if (diwali.length) {
          /* move Diwali entries to the top, keep their relative order.
             8 Oct 2026: only move an entry that is not already in its slot. A move is a DOM mutation even when
             the order does not change, and watchBird() reacts to every mutation, so moving all of them on every
             run kept this running about 8 times a second on an idle Diwali cart. */
          diwali.forEach(function (it, i) { if (list.childNodes[i] !== it) list.insertBefore(it, list.childNodes[i] || null); });
          rest.forEach(function (it) { show(it, false); });
          diwali.forEach(function (it) { show(it, true); });
          var sel = list.querySelector('.bird-location-item--selected');
          if (!sel || !isDiwali(sel)) diwali[0].click();
        }
      } else if (mode === EVERYDAY) {
        items.forEach(function (it) { show(it, !isDiwali(it)); });
        var sel2 = list.querySelector('.bird-location-item--selected');
        var firstVisible = items.filter(function (it) { return !isDiwali(it); })[0];
        if (sel2 && isDiwali(sel2) && firstVisible) firstVisible.click();
      } else {
        items.forEach(function (it) { show(it, true); });
      }
    } finally { setTimeout(function () { birdBusy = false; }, 50); }
  }
  function watchBird() {
    var box = doc.getElementById('birdchime-slots-box');
    if (!box || typeof MutationObserver === 'undefined') return;
    var t = null;
    var schedule = function () { clearTimeout(t); t = setTimeout(function () { arrangeBird(current()); birdGate(current()); }, 120); };
    new MutationObserver(schedule).observe(box, { childList: true, subtree: true });
    watchBirdTaps();
    schedule();
  }

  /* ---------- v4.8 (2026-09-26, Abhi: "build both and push live") ----------
     1. EVERYDAY bags open on Shipping. About 3 in 4 everyday orders are delivered, while about 2 in 3
        Diwali pre-orders are collected (2025: 1,223 of 1,877), so Diwali bags keep Bird's Store Pickup
        default. We tap Bird's Shipping tab ONCE per cart, only if the shopper has not tapped a tab
        themselves and no date is booked; their own tap always wins.
     2. On the pickup tab the shopper must TAP their store before the calendar shows. arrangeBird()
        still selects a valid store in the background (Bird must never sit on a hidden one), but until
        a real tap nothing reads as chosen and the date picker is held back (CSS in pd-qw.css, keyed on
        the class below). Before this, the first Diwali store (Arndell Park) was preselected and about a
        third of Sydney Diwali pickups are Kellyville.
     State is per cart token in localStorage, so a choice survives reloads. Bird's markup is only read
     and clicked, never rewritten; the gate is one class on #birdchime-slots-box. */
  var cartToken = null, cartAttrs = {}, tokenAsked = false, shipTries = 0, storeTries = 0, tappedStore = '', tappedTab = false;
  function lsGet(k) { try { return doc.defaultView.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { doc.defaultView.localStorage.setItem(k, v); } catch (e) { /* private mode, no storage */ } }
  function askToken() {
    if (tokenAsked || !hasFetch()) return;
    tokenAsked = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.token) return;
        cartToken = String(c.token);
        cartAttrs = c.attributes || {};
        if (tappedStore) lsSet('pd-bird-store:' + cartToken, tappedStore);
        if (tappedTab) lsSet('pd-bird-method:' + cartToken, 'user');
        birdGate(current());
      })
      .catch(function () {});
  }
  function birdGate(mode) {
    var box = doc && doc.getElementById('birdchime-slots-box');
    if (!box) return;
    if (!cartToken) { askToken(); return; }
    var booked = !!(cartAttrs['Delivery Date'] && String(cartAttrs['Delivery Date']).trim());
    if (mode === EVERYDAY && !booked && !tappedTab && !lsGet('pd-bird-method:' + cartToken) && shipTries < 3) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('.bird-method-tab'));
      var ship = tabs.filter(function (b) { return /ship/i.test(b.textContent || ''); })[0];
      if (ship) {
        if (ship.classList.contains('bird-method-tab--active')) lsSet('pd-bird-method:' + cartToken, 'auto');
        else { shipTries++; ship.click(); }
      }
    }
    /* Bird does not keep the store across a reload until a date is booked, and arrangeBird() then
       reselects the first Diwali store. So remember WHICH store was tapped, put it back, and only call
       it chosen when that exact store is the selected one. If it cannot be put back, ask again. */
    var want = tappedStore || lsGet('pd-bird-store:' + cartToken) || '';
    var nameOf = function (it) { var n = it && it.querySelector('.bird-location-item__name'); return n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : ''; };
    var sel = box.querySelector('.bird-location-item--selected');
    if (!booked && want && sel && nameOf(sel) !== want && storeTries < 3) {
      var back = Array.prototype.slice.call(box.querySelectorAll('.bird-location-item:not(.pd-bird-hidden)'))
        .filter(function (it) { return nameOf(it) === want; })[0];
      if (back) { storeTries++; back.click(); sel = back; }
    }
    var chosen = booked || !!(want && sel && nameOf(sel) === want);
    if (box.classList.contains('pd-store-unchosen') === chosen) box.classList.toggle('pd-store-unchosen', !chosen);
  }
  var tapsBound = false;
  function watchBirdTaps() {
    if (tapsBound) return;
    tapsBound = true;
    /* only a real tap counts (isTrusted): arrangeBird() and birdGate() click Bird programmatically */
    doc.addEventListener('click', function (e) {
      var el = e.target;
      if (!e.isTrusted || !el || !el.closest) return;
      if (el.closest('#birdchime-slots-box .bird-method-tab')) {
        tappedTab = true;
        if (cartToken) lsSet('pd-bird-method:' + cartToken, 'user');
      }
      var item = el.closest('#birdchime-slots-box .bird-location-item');
      if (item && !item.classList.contains('pd-bird-hidden')) {
        var nm = item.querySelector('.bird-location-item__name');
        tappedStore = nm ? (nm.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (cartToken && tappedStore) lsSet('pd-bird-store:' + cartToken, tappedStore);
        var box = doc.getElementById('birdchime-slots-box');
        if (box) box.classList.remove('pd-store-unchosen');
      }
    }, true);
  }

  /* ---------- v2.8: "before you pay" check (cart page) ----------
     Repeats what Bird currently holds — method, location, date, time — and
     asks for a yes. Reads cart attributes (Bird writes "Delivery Method",
     "Delivery Location" and _BirdChimeSlotId "M=P;L=..;D=..;T=..") and the
     rendered widget text. Bird itself is not touched. */
  var ckConfirmed = false, ckForm = null, ckSubmitter = null;
  function ckText(sel) { var el = doc.querySelector(sel); return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function ckSlot(attrs) {
    var out = { date: '', time: '' };
    var raw = attrs && attrs._BirdChimeSlotId;
    if (!raw) return out;
    var m = /(?:^|;)D=([^;]*)/.exec(raw); if (m && m[1]) out.date = m[1];
    var t = /(?:^|;)T=([^;]*)/.exec(raw); if (t && t[1]) out.time = t[1];
    return out;
  }
  function ckSummary(attrs) {
    attrs = attrs || {};
    var method = (attrs['Delivery Method'] || ckText('.bird-method-tab--active .bird-method-tab__label') || '').toLowerCase();
    var isPickup = /pick/.test(method), isShip = /ship|deliver/.test(method);
    var loc = ckText('.bird-location-item--selected .bird-location-item__name') || attrs['Delivery Location'] || '';
    var dateEl = doc.querySelector('.bird-date-picker__value');
    var dateText = dateEl && !/placeholder/.test(dateEl.className) ? (dateEl.textContent || '').trim() : '';
    var slot = ckSlot(attrs);
    var when = dateText || slot.date;
    if (slot.time) when += (when ? ', ' : '') + slot.time;
    var html = 'Your order is set for ';   /* [QA 4 Oct 2026] was "set to delivery to the address" */
    if (isPickup) html += '<b>store pick-up</b>' + (loc ? ' at <b>' + esc(loc) + '</b>' : '');
    else if (isShip) html += '<b>delivery</b> to the address you enter at checkout';
    else html = 'Your order has <b>no pick-up or delivery method yet</b>';
    html += when ? ', on <b>' + esc(when) + '</b>.' : '. <b>No date has been chosen yet.</b>';
    return { html: html, complete: !!((isPickup || isShip) && when) };
  }
  function ckRender(d, res) {
    var sum = d.querySelector('[data-pd-ck-summary]');
    if (sum) sum.innerHTML = res.html;
    /* without a method and a date there is nothing to confirm: only offer the way back to Bird */
    var yes = d.querySelector('[data-pd-ck-yes]'), change = d.querySelector('.pd-switch__actions [data-pd-ck-change]');
    if (yes) yes.hidden = !res.complete;
    if (change) change.textContent = res.complete ? 'Change pick-up or delivery' : 'Choose your pick-up or delivery first';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* v2.9b: the dialog is rendered inside the cart subtotal widget, which is
     position:sticky with z-index:0 on phones — a stacking context that keeps
     the fixed dialog under the sticky header. Move it to <body> before it
     opens (and drop any duplicate the cart re-render may have inserted). */
  function ckEl() {
    var all = doc.querySelectorAll('#pd-ckcheck');
    if (!all.length) return null;
    var d = all[0];
    for (var i = 1; i < all.length; i++) { if (all[i].parentNode) all[i].parentNode.removeChild(all[i]); }
    if (d.parentNode !== doc.body) doc.body.appendChild(d);
    return d;
  }
  function openCheck(form, submitter) {
    var d = ckEl();
    if (!d) return;
    ckForm = form; ckSubmitter = submitter;
    ckRender(d, ckSummary(null));
    d.hidden = false;
    doc.documentElement.classList.add('pd-switch-open');
    var focusEl = d.querySelector('[data-pd-ck-yes]:not([hidden])') || d.querySelector('.pd-switch__actions [data-pd-ck-change]'); if (focusEl) focusEl.focus();
    if (hasFetch()) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && !d.hidden) ckRender(d, ckSummary(c.attributes || {})); })
        .catch(function () { /* keep the DOM-only summary */ });
    }
  }
  function closeCheck(scrollToBird) {
    var d = doc.getElementById('pd-ckcheck');
    if (d) d.hidden = true;
    doc.documentElement.classList.remove('pd-switch-open');
    ckForm = null; ckSubmitter = null;
    if (scrollToBird) { var b = doc.getElementById('birdchime-slots-box'); if (b) b.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  }
  /* v4.9 (2026-09-26, Abhi: "build 1, 2 and 3"): Shopify's checkout takes a few seconds to open (about 4 s in a
     test). The sheet now stays up and says so, a second tap does nothing, and the other buttons wait. If the page is
     still here after 10 s (nothing opened) or the shopper comes back with Back, it resets. */
  var ckGoing = false, ckGoTimer = 0;
  function ckGoOn(d) {
    ckGoing = true;
    d.classList.add('pd-ck--going');
    var y = d.querySelector('[data-pd-ck-yes]');
    if (y) {
      if (!y.hasAttribute('data-pd-label')) y.setAttribute('data-pd-label', y.textContent);
      y.textContent = 'Opening secure checkout\u2026';
      var bar = doc.createElement('span'); bar.className = 'pd-ck-bar'; bar.setAttribute('aria-hidden', 'true');
      y.appendChild(bar);
      y.setAttribute('aria-busy', 'true');
    }
    clearTimeout(ckGoTimer);
    ckGoTimer = setTimeout(function () { ckGoOff(true); }, 10000);
  }
  function ckGoOff(close) {
    clearTimeout(ckGoTimer);
    if (!ckGoing) return;
    ckGoing = false;
    ckConfirmed = false;   /* nothing opened: the next checkout tap asks again */
    var d = doc.getElementById('pd-ckcheck');
    if (d) {
      d.classList.remove('pd-ck--going');
      var y = d.querySelector('[data-pd-ck-yes]');
      if (y && y.hasAttribute('data-pd-label')) { y.textContent = y.getAttribute('data-pd-label'); y.removeAttribute('aria-busy'); }
    }
    if (close) closeCheck(false);
  }
  function confirmCheck() {
    var f = ckForm, s = ckSubmitter;
    if (ckGoing) return;
    var d = doc.getElementById('pd-ckcheck');
    if (f && d && !d.hidden) ckGoOn(d); else closeCheck(false);
    if (!f) return;
    ckConfirmed = true;
    if (typeof f.requestSubmit === 'function') { try { s ? f.requestSubmit(s) : f.requestSubmit(); return; } catch (err) { /* fall through */ } }
    if (s) s.click(); else f.submit();
  }

  function dialogEl() { return doc ? doc.getElementById('pd-switch') : null; }
  function openDialog(mode, target, form) {
    var d = dialogEl();
    if (!d) { location.href = '/cart'; return; }
    var c = dialogCopy(mode, target);
    d.querySelector('[data-pd-dialog-title]').textContent = c.title;
    d.querySelector('[data-pd-dialog-body]').textContent = c.body;
    var sw = d.querySelector('[data-pd-switch]');
    if (c.switchLabel) { sw.hidden = false; sw.textContent = c.switchLabel; } else { sw.hidden = true; }
    pending = form || null;
    d.hidden = false;
    doc.documentElement.classList.add('pd-switch-open');
    var first = d.querySelector('[data-pd-go-bag]');
    if (first) first.focus();
  }
  function closeDialog() {
    var d = dialogEl();
    if (d) d.hidden = true;
    doc.documentElement.classList.remove('pd-switch-open');
    pending = null;
  }
  function clearAndResubmit() {
    var form = pending;
    var d = dialogEl();
    var sw = d && d.querySelector('[data-pd-switch]');
    if (sw) sw.classList.add('working');
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        setMode(NONE);
        closeDialog();
        if (sw) sw.classList.remove('working');
        if (form && form.isConnected) {
          /* requestSubmit re-fires the submit event: the capture listener sees
             mode=none, no conflict, and the theme's own handler runs. */
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        } else {
          location.reload();
        }
      })
      .catch(function () { if (sw) sw.classList.remove('working'); location.href = '/cart'; });
  }

  function _boot(w) {
    doc = w.document;
    /* 1. Add intercept — capture phase, so it runs before the theme's
          ProductForm submit handler (attached on the form element). */
    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var t = form.getAttribute('data-pd-type');
      if (!t) return;
      var mode = current();
      if (!conflicts(mode, t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openDialog(mode, t, form);
    }, true);
    /* 1b. Quick-view anchors (multi-variant cards): a locked card must not
          even open the modal. */
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('quick-view-product[data-pd-type] a') : null;
      if (!a) return;
      var t = a.parentNode.getAttribute('data-pd-type');
      if (!conflicts(current(), t)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      openDialog(current(), t, null);
    }, true);
    /* 2. Dialog buttons and PDP lock panel buttons. */
    doc.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (el.closest('[data-pd-switch]')) { e.preventDefault(); clearAndResubmit(); }
      else if (el.closest('[data-pd-close]')) { e.preventDefault(); closeDialog(); }
      else if (el.closest('[data-pd-open-switch]')) {
        e.preventDefault();
        var host = el.closest('[data-pd-open-switch]');
        openDialog(current(), host.getAttribute('data-pd-open-switch'), null);
      }
    });
    doc.addEventListener('keydown', function (e) {
      var d = dialogEl();
      if (e.key === 'Escape' && d && !d.hidden) closeDialog();
    });
    /* 3. Keep the mode honest after ajax cart changes. The theme's add-to-cart
          event does not bubble: capture phase. */
    doc.addEventListener('add-to-cart', function () { sync(); }, true);
    doc.addEventListener('cart-updated', function () { sync(); }, true);
    /* 4. Cart page resolve buttons: remove the OTHER group's lines. */
    doc.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-pd-keep]') : null;
      if (!b) return;
      e.preventDefault();
      var keep = b.getAttribute('data-pd-keep');
      b.classList.add('working');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var updates = {};
          (c.items || []).forEach(function (it) { var lt = lineType(it); if (lt !== keep && lt !== ANY) updates[it.key] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function () { location.reload(); })
        .catch(function () { b.classList.remove('working'); location.reload(); });
    });
    /* 5. Belt and braces: never let a mixed bag submit the checkout.
          v2.8 (2026-09-12): every other bag gets the "before you pay" check
          (snippets/pd-checkout-check.liquid) once per press of the button. */
    doc.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.id !== 'cart') return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      if (current() === MIXED) {
        e.preventDefault(); e.stopImmediatePropagation();
        var p = doc.querySelector('[data-pd-resolve]');
        if (p) p.scrollIntoView({ block: 'center' });
        return;
      }
      if (ckConfirmed) { ckConfirmed = false; return; }
      var dlg = doc.getElementById('pd-ckcheck');
      if (!dlg) return;
      e.preventDefault(); e.stopImmediatePropagation();
      openCheck(f, submitter);
    }, true);
    doc.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (el.closest('[data-pd-ck-yes]')) { e.preventDefault(); confirmCheck(); }
      else if (el.closest('[data-pd-ck-change]')) { e.preventDefault(); if (!ckGoing) closeCheck(true); }
    });
    doc.addEventListener('keydown', function (e) {
      var d = doc.getElementById('pd-ckcheck');
      if (e.key === 'Escape' && d && !d.hidden && !ckGoing) closeCheck(false);
    });
    /* back from Shopify's checkout (the page may come back from the browser's cache): the sheet must not still spin */
    if (doc.defaultView) doc.defaultView.addEventListener('pageshow', function (e) { if (e.persisted) ckGoOff(true); });
    /* 6. First paint already carries the Liquid mode; apply locks now and
          confirm against /cart.js once. */
    /* 7. 28 Sep 2026 (critique fix #1, Abhi: "the terms tick box removed because the Before-you-pay sheet already
          covers it"). Every checkout press passes through the sheet (section 5), and the sheet says "By continuing
          you accept our terms and conditions" (or the Diwali pre-order terms). While the sheet is on the page, the
          cart's own tick box is ticked and hidden here; with no script it stays exactly as it was. The theme
          re-renders the subtotal (tick box included) on every quantity change, so this runs again then. */
    var termsToSheet = function () {
      if (!doc.getElementById('pd-ckcheck')) return;
      var b = doc.getElementById('AgreeToTos-page');
      if (!b) return;
      b.required = false;
      if (!b.checked) {
        b.checked = true;
        try { b.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) { /* old browsers: the ticked box still passes */ }
      }
      doc.documentElement.classList.add('pd-terms-in-sheet');
    };
    var watchTerms = function () {
      termsToSheet();
      if (!doc.defaultView || !doc.defaultView.MutationObserver) return;
      var hosts = doc.querySelectorAll('#AjaxCartSubtotal');
      for (var i = 0; i < hosts.length; i++) new doc.defaultView.MutationObserver(termsToSheet).observe(hosts[i], { childList: true, subtree: true });
    };
    var ready = function () { applyLocks(current()); sync(); if (doc.body.classList.contains('template-cart')) { watchBird(); watchTerms(); } };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready); else ready();
  }

  return {
    lineType: lineType, resolveMode: resolveMode, conflicts: conflicts,
    dialogCopy: dialogCopy, lockLabel: lockLabel,
    current: function () { return current(); }, sync: function () { return sync(); },
    applyLocks: function (m) { return applyLocks(m); }, openDialog: openDialog, _boot: _boot
  };
});
